import { render, staticRenderFns } from "./_EditAdditionalModal.vue?vue&type=template&id=67f880f3&"
import script from "./_EditAdditionalModal.vue?vue&type=script&lang=js&"
export * from "./_EditAdditionalModal.vue?vue&type=script&lang=js&"
import style0 from "./_EditAdditionalModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports